import type { LimitOrderPlacementRequest, LimitOrderResponse } from 'apiConnector/secondary-market/limit-order/models';
import { secondaryMarketOrderPlacementActionsFactory } from 'state/secondaryMarket/shared/order/order.action';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export const limitOrderOrderActions = {
  ...secondaryMarketOrderPlacementActionsFactory<LimitOrderPlacementRequest, LimitOrderResponse>('LIMIT_ORDER'),
  secondaryMarketOrderCanceled(tabId: string, workspaceType: SecondaryWorkspaceType) {
    return {
      type: `SECONDARY_MARKET_LIMIT_ORDER_CANCELED` as const,
      tabId,
      workspaceType,
    };
  },
};
type TypeofLimitOrderActions = typeof limitOrderOrderActions;
export type SecondaryMarketLimitOrderPlacementRequested = ReturnType<
  TypeofLimitOrderActions['secondaryMarketOrderPlacementRequested']
>;
export type SecondaryMarketLimitOrderOrderCanceled = ReturnType<
  TypeofLimitOrderActions['secondaryMarketOrderCanceled']
>;

export type SecondaryMarketLimitOrderPlacementReceived = ReturnType<
  TypeofLimitOrderActions['secondaryMarketOrderPlacementReceived']
>;
export type SecondaryMarketLimitOrderOrderFailed = ReturnType<
  TypeofLimitOrderActions['secondaryMarketOrderPlacementFailed']
>;
export type SecondaryMarketLimitOrderOrderRejected = ReturnType<
  TypeofLimitOrderActions['secondaryMarketOrderPlacementRejected']
>;
export type SecondaryMarketLimitOrderOrderActions = ReturnType<TypeofLimitOrderActions[keyof TypeofLimitOrderActions]>;
